import { Component, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'mojo-tilebar',
  templateUrl: './tilebar.component.html'
})
export class TileBarComponent {

  @ViewChild('scrollbar', { static: true }) scrollbar: ElementRef;

  constructor(private cd: ChangeDetectorRef) { }

  ngAfterViewChecked() {
    this.cd.detectChanges();
  }
  
  scrollLeft(): void {
    this.scrollbar.nativeElement.scrollLeft -= this.getScrollablePanelWidth();
  }

  scrollRight(): void {
    this.scrollbar.nativeElement.scrollLeft += this.getScrollablePanelWidth();
  }

  isScrollable(): boolean {
    const el = this.scrollbar.nativeElement;
    return (el.offsetWidth !== el.scrollWidth);
  }

  onResize(): void {
    this.cd.detectChanges();
  }

  private getScrollablePanelWidth(): number {
    return this.scrollbar.nativeElement.clientWidth;
  }
}
